<div style="padding: 0">
  <div style="padding: 20px; -webkit-box-shadow: 0px 2px 1px 0px rgba(240,240,240,1);
       -moz-box-shadow: 0px 2px 1px 0px rgba(240,240,240,1);
       box-shadow: 0px 2px 1px 0px rgba(240,240,240,1)">
    <h4 style=" margin-bottom: 0; margin-top: 0">Create a lawyer for
      property {{data.property.unitNum}}</h4>
  </div>
  <div style="padding: 20px; overflow: scroll">
    <form [formGroup]="lawyerInfoForm">
      <div style="display: flex; justify-content: space-between">
        <mat-form-field appearance="outline" style="width: 45%">
          <mat-label>First name</mat-label>
          <input matInput formControlName="firstName">
          <mat-error *ngIf="f.firstName.errors && f.firstName.errors.required">
            First name is required
          </mat-error>
          <mat-error
            *ngIf="!lawyerInfoForm.hasError('minLength', 'firstName') &&  !lawyerInfoForm.hasError('maxLength', 'firstName') && f.firstName.errors && !f.firstName.errors.required">
            First name should be {{constants.MIN_FIRSTNAME_LENGTH}} - {{constants.MAX_FIRSTNAME_LENGTH}}
          </mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline" style="width: 45%">
          <mat-label>Last name</mat-label>
          <input matInput formControlName="lastName">
          <mat-error *ngIf="f.lastName.errors && f.lastName.errors.required">
            Last name is required
          </mat-error>
          <mat-error
            *ngIf="!lawyerInfoForm.hasError('minLength', 'lastName') &&  !lawyerInfoForm.hasError('maxLength', 'lastName') && f.lastName.errors && !f.lastName.errors.required">
            Last name should be {{constants.MIN_LASTNAME_LENGTH}} - {{constants.MAX_LASTNAME_LENGTH}}
          </mat-error>
        </mat-form-field>
      </div>
      <div style="display: flex; justify-content: space-between">
        <mat-form-field appearance="outline" style="width: 45%">
          <mat-label>Email</mat-label>
          <input matInput formControlName="email">
          <mat-error *ngIf="f.email.errors && f.email.errors.required">
            Email is required
          </mat-error>
          <mat-error *ngIf="!lawyerInfoForm.hasError('maxLength', 'email') && !lawyerInfoForm.get('email').hasError('pattern') && f.email.errors && !f.email.errors.required">
            Email maximum length is {{constants.MAX_EMAIL_LENGTH}}
          </mat-error>
          <mat-error *ngIf="lawyerInfoForm.get('email').hasError('pattern') && f.email.errors && !f.email.errors.required">
            Please enter a valid email
          </mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline" style="width: 45%">
          <mat-label>Phone</mat-label>
          <input matInput formControlName="phoneNumber">
          <mat-error *ngIf="f.phoneNumber.errors && f.phoneNumber.errors.required">
            Phone is required
          </mat-error>
          <mat-error
            *ngIf="!lawyerInfoForm.hasError('maxLength', 'phoneNumber') && !lawyerInfoForm.get('phoneNumber').hasError('pattern') && f.phoneNumber.errors && !f.phoneNumber.errors.required">
            Phone length should be {{constants.MIN_PHONE_NUMBER_LENGTH}} - {{constants.MAX_PHONE_NUMBER_LENGTH}}
          </mat-error>
          <mat-error *ngIf="lawyerInfoForm.get('phoneNumber').hasError('pattern') && f.phoneNumber.errors && !f.phoneNumber.errors.required">
            Please enter a valid phone
          </mat-error>
        </mat-form-field>
      </div>
      <mat-form-field appearance="outline" style="width: 45%">
        <mat-label>Law firm</mat-label>
        <input matInput formControlName="lawFirm">
        <mat-error *ngIf="!lawyerInfoForm.hasError('maxLength', 'lawFirm')">
          Law firm maximum length is {{constants.MAX_COMPANYNAME_LENGTH}}
        </mat-error>
      </mat-form-field>
      <div>
        <button mat-button (click)="submit()" style="background: #3C50E0; color: #fff;  margin-top: 20px; margin-bottom: 0">
          Create lawyer
        </button>
      </div>
    </form>
  </div>
</div>